<div class="shop-dialog">
    <div class="dialog-header">
        <h2>Select Shops</h2>
        <button mat-icon-button (click)="onCancel()">
            <mat-icon>close</mat-icon>
        </button>
    </div>

    <div class="dialog-body">
        <div class="search-box">
            <mat-form-field appearance="outline">
                <mat-label>Search Shops</mat-label>
                <input matInput [(ngModel)]="searchQuery" placeholder="Filter by name or code..." autocomplete="off">
                <mat-icon matSuffix>search</mat-icon>
            </mat-form-field>
        </div>

        <div class="actions-row">
            <span class="count" *ngIf="selectedIds.length > 0">Selected: {{ getSelectedShopName() }}</span>
            <span class="count" *ngIf="selectedIds.length === 0">No shop selected</span>
        </div>

        <div class="shop-list">
            <div class="shop-item" *ngFor="let shop of filteredShops" (click)="toggleSelection(shop.id)">
                <div class="shop-item-content">
                    <mat-radio-button [checked]="isSelected(shop.id)" (click)="$event.stopPropagation(); toggleSelection(shop.id)">
                        {{ shop.name }} <span class="shop-code-hint" *ngIf="shop.code">({{ shop.code }})</span>
                    </mat-radio-button>
                    <span class="emp-count" matTooltip="Number of employees">
                        <mat-icon>people</mat-icon>
                        {{ shop.employee_count || 0 }}
                    </span>
                </div>
            </div>
            <div class="no-results" *ngIf="filteredShops.length === 0">
                No shops found matching "{{ searchQuery }}"
            </div>
        </div>
    </div>

    <div class="dialog-actions">
        <button mat-button (click)="onCancel()">Cancel</button>
        <button mat-flat-button color="primary" (click)="onApply()">Apply</button>
    </div>
</div>